import { render, staticRenderFns } from "./ExamStatusModal.vue?vue&type=template&id=552c4928&scoped=true"
import script from "./ExamStatusModal.vue?vue&type=script&lang=js"
export * from "./ExamStatusModal.vue?vue&type=script&lang=js"
import style0 from "./ExamStatusModal.vue?vue&type=style&index=0&id=552c4928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c4928",
  null
  
)

export default component.exports